import { z } from 'zod';

/** Forms file upload returns a plain-text CDN path/URL. */
export const postFileResponseSchema = z.string().min(1);
